import type { FC } from 'react';
import { TooltipedIcon } from '@components/TooltipedIcon';
import { mdiHelpCircleOutline } from '@mdi/js';
import clsx from 'clsx';

import type { UIComponentBase } from '../../@types/types';

interface H2Props extends UIComponentBase {
  helperText?: string;
}

const H2: FC<H2Props> = ({ className, children, helperText }) => {
  return (
    <h2 className={clsx('flex justify-start gap-2 text-2xl leading-9 font-semibold', className)}>
      {children}
      {helperText && <TooltipedIcon path={mdiHelpCircleOutline} placement="top" content={helperText} />}
    </h2>
  );
};

export default H2;
